const makePrice = (locale: string) => ({
  parseAndFormat: (amount: number, currency: string, printUnit = true) => {
    const valueInPLN = amount / 100;

    if (!printUnit) {
      return Intl.NumberFormat(locale, { minimumFractionDigits: 2 }).format(valueInPLN);
    }

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(valueInPLN);
  },
});

export default makePrice;
